var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVehicleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 68,
    viewBox: "0 0 107 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.5508 59.143H43.6134C43.4122 58.1964 43.1924 57.1798 42.9788 56.1591C41.0459 47.014 31.8501 44.349 26.0203 46.6888C21.1465 48.6459 18.2596 52.2142 17.7163 57.5008C17.681 57.8404 17.6582 58.182 17.6167 58.5215C17.6001 58.6553 17.5462 58.7829 17.484 59.001H16.3724C12.5066 59.001 8.63871 58.9064 4.77913 59.0381C2.64299 59.1121 0.280789 57.1325 0.119023 54.8688C-1.14607 37.2288 7.71581 22.9925 23.7203 17.0968C29.6289 14.9196 35.7366 14.1355 42.004 14.3969C43.6217 14.4648 44.1713 15.0739 44.1713 16.6873C44.1713 23.5708 44.1713 30.4523 44.1713 37.3358C44.1713 37.7392 44.1713 38.1425 44.1713 38.659H45.4778C60.2836 38.659 75.0873 38.6488 89.893 38.6693C92.5829 38.6735 95.2728 38.7722 97.9606 38.8957C100.215 38.9986 101.335 39.9617 101.592 42.1739C101.808 44.0383 101.837 45.9274 101.86 47.8083C101.889 50.1028 101.818 52.3973 101.806 54.6898C101.795 56.4884 100.698 57.6696 99.402 58.6532C98.5745 59.2809 98.5288 58.4639 98.5143 57.9268C98.4355 55.1363 97.3716 52.7225 95.5714 50.644C92.361 46.9358 88.2774 45.2504 83.3892 46.1229C78.3661 47.0201 75.1121 50.1296 73.4675 54.8627C73.0133 56.1673 72.8765 57.5811 72.5529 59.1451L72.5508 59.143ZM26.3542 34.994V34.9611C29.4215 34.9611 32.4888 34.9611 35.5562 34.9611C37.1593 34.9611 37.7151 34.531 37.7483 32.8929C37.8126 29.8185 37.7939 26.7379 37.7296 23.6634C37.6985 22.19 37.4746 22.013 35.9834 22.0603C30.3278 22.2353 25.1762 23.9495 20.5285 27.1474C18.2431 28.7196 16.2687 30.6149 14.7008 32.9012C14.1346 33.7264 14.23 34.2141 15.1612 34.5907C15.8373 34.8644 16.6233 34.9693 17.3616 34.9796C20.3585 35.0207 23.3573 34.9961 26.3562 34.9961L26.3542 34.994Z",
    fill: "url(#paint0_linear_1_1941)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.58 17.9013C83.58 22.6591 83.5883 27.419 83.5717 32.1767C83.5696 32.9258 83.4784 33.679 83.3788 34.4239C83.2005 35.7698 82.4248 36.5044 81.0664 36.595C80.0004 36.667 78.9303 36.7143 77.8622 36.7123C69.9626 36.6999 62.063 36.6835 54.1655 36.6402C52.6536 36.632 51.1334 36.5785 49.6319 36.4098C48.3025 36.2616 47.1411 34.8273 47.0851 33.4794C47.0644 32.9999 47.081 32.5204 47.081 32.0409C47.0934 23.0357 47.1038 14.0326 47.1308 5.02736C47.1328 4.20833 47.2179 3.38724 47.3216 2.57439C47.5041 1.16475 48.3855 0.265464 49.8165 0.141992C51.1563 0.0288101 52.5043 0 53.8503 0C62.6831 0 71.516 0.0205786 80.3467 0.0226365C81.419 0.0226365 82.4684 0.121414 83.1154 1.07215C83.4576 1.57426 83.7749 2.21838 83.7812 2.80281C83.833 7.83634 83.8102 12.8699 83.8102 17.9013H83.58Z",
    fill: "url(#paint1_linear_1_1941)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5029 58.8507C39.5195 64.7156 35.2762 67.9259 30.0105 67.9979C25.4687 68.0617 21.1113 63.946 21.327 58.3486C21.5095 53.6258 25.7694 49.6459 30.7364 49.7611C35.6039 49.8743 39.5942 54.0106 39.5029 58.8486V58.8507Z",
    fill: "url(#paint2_linear_1_1941)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5711 67.6049C82.2549 68.1523 79.7579 66.7242 78.076 64.016C74.9651 59.0092 76.8938 50.7161 84.5653 49.862C88.2403 49.4525 91.5005 50.7634 93.4831 54.093C95.4347 57.3712 95.3704 60.7605 93.3359 64.0078C91.5668 66.8291 88.9682 68.0906 85.5711 67.607V67.6049Z",
    fill: "url(#paint3_linear_1_1941)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.99 7.65119C94.2379 7.65119 91.4837 7.67176 88.7316 7.6409C87.7091 7.62855 86.919 6.84245 86.8899 5.94522C86.863 5.14471 87.5287 4.58497 88.7233 4.58085C94.2337 4.56028 99.7421 4.56439 105.252 4.5932C105.868 4.59732 106.636 4.53147 106.891 5.34844C107.136 6.13248 106.957 6.87331 106.323 7.39395C106.018 7.64295 105.549 7.8117 105.151 7.81581C102.43 7.8508 99.7089 7.83433 96.9879 7.83433C96.9879 7.7726 96.9879 7.71292 96.9879 7.65119H96.99Z",
    fill: "url(#paint4_linear_1_1941)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1367 11.1042C94.9638 11.1042 96.7951 11.0239 98.6118 11.1556C99.1303 11.1927 99.7981 11.7483 100.057 12.2401C100.601 13.267 99.9142 14.4153 98.73 14.4317C95.1484 14.4832 91.5667 14.4441 87.985 14.4029C87.2612 14.3947 86.7075 13.5963 86.7407 12.7978C86.7884 11.6742 87.5474 10.9519 88.6839 10.9519C90.1689 10.9519 91.6517 10.9519 93.1367 10.9519C93.1367 11.0034 93.1367 11.0548 93.1367 11.1042Z",
    fill: "url(#paint5_linear_1_1941)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7924 21.9863C91.2743 21.9863 89.7561 22.0377 88.2422 21.9718C87.1223 21.9225 86.6038 21.2434 86.6556 20.1259C86.7033 19.0744 87.5453 18.1442 88.4848 18.1627C91.1747 18.2121 93.8667 18.2492 96.5524 18.3706C97.1642 18.3973 97.944 18.5764 98.3194 18.9838C98.7114 19.4098 98.8897 20.2083 98.8379 20.8153C98.7736 21.5541 98.112 21.9657 97.3446 21.9801C95.8286 22.0089 94.3105 21.9883 92.7924 21.9904V21.9863Z",
    fill: "url(#paint6_linear_1_1941)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1941",
    x1: 50.7462,
    y1: 7.11315,
    x2: 50.7674,
    y2: 59.1451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7351",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#583095",
    stopOpacity: 0.79
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_1941",
    x1: 65.3775,
    y1: -5.92963,
    x2: 65.4171,
    y2: 36.7124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7351",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#583095",
    stopOpacity: 0.79
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_1941",
    x1: 30.3785,
    y1: 46.8126,
    x2: 30.3982,
    y2: 67.9986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7351",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#583095",
    stopOpacity: 0.79
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_1941",
    x1: 85.7471,
    y1: 46.8933,
    x2: 85.7661,
    y2: 67.7206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7351",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#583095",
    stopOpacity: 0.79
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_1941",
    x1: 96.9058,
    y1: 4.0398,
    x2: 96.9064,
    y2: 7.83821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7351",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#583095",
    stopOpacity: 0.79
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_1941",
    x1: 93.4679,
    y1: 10.3859,
    x2: 93.4689,
    y2: 14.4563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7351",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#583095",
    stopOpacity: 0.79
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_1941",
    x1: 92.727,
    y1: 17.5418,
    x2: 92.7283,
    y2: 22.0054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7351",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#583095",
    stopOpacity: 0.79
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleIcon);
export default __webpack_public_path__ + "static/media/vehicle-icon.01cbe28ff2a5e5415268b79a04b6b2c4.svg";
export { ForwardRef as ReactComponent };